import { Box, Paper, Theme } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import makeStyles from '@mui/styles/makeStyles';
import {
  EnhancedTableToolbar,
  ToolbarAddDeleteButton,
} from '../Manage/pages/queues-table/EnhancedTableToolbar';

const useStyles = makeStyles((theme: Theme) => ({
  skeleton: {
    backgroundColor: theme.palette.mode === 'dark' ? 'grey' : 'lightgrey',
    height: '6em',
    margin: 10,
  },
}));

const skeletonCallback = () => {};

export const QueuesSkeleton = () => {
  const classes = useStyles();
  return (
    <Paper elevation={0}>
      <EnhancedTableToolbar
        search={''}
        setSearch={skeletonCallback}
        isLoading={true}
        numSelected={0}
        rightComponent={
          <ToolbarAddDeleteButton
            numSelected={0}
            onClickForAdd={skeletonCallback}
            onClickForDelete={skeletonCallback}
            isLoading={true}
          />
        }
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Skeleton
        className={classes.skeleton}
        variant="rectangular"
        height={50}
      />
      <Box display="flex" margin={1} justifyContent="flex-end">
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
    </Paper>
  );
};
